import { Flex, RadioGroup, RadioGroupItem, Text } from "@radix-ui/themes";
import React, { useEffect, useState } from "react";

interface Option {
  answerId: string;
  value: string;
  isAnswer: string | Boolean;
  isRightAnswer?: Boolean;
}

interface SingleChoiceQuestionProps {
  onChoice: (option: Option, index: number) => void;
  question: string;
  options: Option[];
  isMandatory: boolean;
  index: number;
  onValidate?: (index: number, isValid: boolean) => void;
  assessmentType?: string;
}

const SingleChoiceQuestion: React.FC<SingleChoiceQuestionProps> = ({
  question,
  options,
  isMandatory,
  index,
  onChoice,
  onValidate,
  assessmentType
}) => {
  const [selectedId, setSelectedId] = useState<string | undefined>(
    options.find((o) => o.isAnswer)?.answerId
  );
  const [validationMessage, setValidationMessage] = useState<string | null>(null);

  const handleOptionChange = (answerId: string) => {
    setSelectedId(answerId);
    const selectedOption = options.find((o) => o.answerId === answerId);
    if (selectedOption) {
      onChoice(selectedOption, index);

      if (assessmentType === "quiz") {
        setValidationMessage(
          selectedOption.isRightAnswer 
            ? "Correct Answer" 
            : "Wrong Answer! Try Again"
        );
      }

      if (isMandatory) {
        onValidate(index, true);
      }
    }
  };
  useEffect(() => {
    if (typeof onValidate === "function") {
      if (isMandatory) {
        onValidate(index, !!selectedId);
      }
    }
  }, [isMandatory, index, selectedId, onValidate]);
  // const handleOptionChange = (option: Option) => {
  //   setSelectedOption(option)
  //   onChoice(option, index);
  // };

  return (
    <Flex direction="column" gap="2">
      <Text className="block mb-2 text-normal font-bold text-app-gray-medium" as="label" size="3">
        {question}
        {isMandatory && <span className="text-red-600">*</span>}
      </Text>
      <RadioGroup.Root
        value={selectedId}
        onValueChange={handleOptionChange}
        color="purple"
        variant="classic"
      >
        <Flex direction="column" gap="2">
          {options.map((option) => (
            <Text key={option.answerId} as="label" className="my-auto">
              <Flex
                gap="2"
                className={
                  selectedId === option.answerId
                    ? "border-[0.5px] border-purple-600 rounded-xl shadow-lg py-[1.5%] px-[1%]"
                    : "border-[1px] rounded-xl py-[1%] px-[1%] shadow-sm"
                }
              >
                <RadioGroupItem
                  className="my-auto"
                  value={option.answerId}
                />
                {option.value}
              </Flex>
            </Text>
          ))}
        </Flex>
      </RadioGroup.Root>
      {validationMessage && assessmentType === "quiz" && (
        <Text 
          className={`mt-2 text-sm ${
            validationMessage === "Correct Answer" 
              ? "text-green-600" 
              : "text-red-600"
          }`}
        >
          {validationMessage}
        </Text>
      )}
    </Flex>
  );
};

export default SingleChoiceQuestion;
